import {applyChannels, isApplyCustomLayout} from './const'
import CustomHeader from './CustomHeader'
import CustomHeaderLogo from './CustomHeaderLogo'
import CustomPageWrapper from './CustomPageWrapper'
import CustomLoginWrapper from './CustomLoginWrapper'
import CustomRegisterWrapper from './CustomRegisterWrapper'
import CustomRetrieve from './CustomRetrieve'
import CustomAccountActive from './CustomAccountActive'
import CustomWrapper from './CustomWrapper'
export {
  applyChannels, isApplyCustomLayout,
  CustomHeader, CustomHeaderLogo, CustomPageWrapper,CustomRegisterWrapper,
  CustomLoginWrapper, CustomRetrieve, CustomAccountActive, CustomWrapper
}



// WEBPACK FOOTER //
// ./src/common/custom-layout/index.js